package co.maytes.standupbot.dashboard.components.widgets

import androidx.compose.runtime.Composable
import co.maytes.standupbot.dashboard.styles.ControlHeight
import co.maytes.standupbot.dashboard.styles.Space
import co.maytes.standupbot.dashboard.styles.Typography
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit

enum class ControlSize { Sm, Md, Lg }

internal data class ControlMetrics(
    val height: CSSSizeValue<CSSUnit.px>,
    val padX: CSSSizeValue<CSSUnit.px>,
    val fontSize: CSSSizeValue<CSSUnit.px>,
    val boxPx: Int,
    val switchWidthPx: Int,
    val switchHeightPx: Int,
)

internal val ControlSize.metrics: ControlMetrics
    get() = when (this) {
        ControlSize.Sm -> ControlMetrics(
            height = ControlHeight.sm,
            padX = Space.s2,
            fontSize = Typography.bodySmall.size,
            boxPx = 14,
            switchWidthPx = 28,
            switchHeightPx = 16,
        )
        ControlSize.Md -> ControlMetrics(
            height = ControlHeight.md,
            padX = Space.s3,
            fontSize = Typography.label.size,
            boxPx = 16,
            switchWidthPx = 36,
            switchHeightPx = 20,
        )
        ControlSize.Lg -> ControlMetrics(
            height = ControlHeight.lg,
            padX = Space.s3,
            fontSize = Typography.body.size,
            boxPx = 18,
            switchWidthPx = 44,
            switchHeightPx = 24,
        )
    }

@Deprecated(
    "Build fields with FormField, which wires the label to the control",
    ReplaceWith("FormField(label = text) { }"),
)
@Composable
fun FieldLabel(text: String) = FieldLabelText(text = text, forId = null, required = false)

@Deprecated(
    "Pass hint to FormField, which links it to the control with aria-describedby",
    ReplaceWith("FormField(label = null, hint = text) { }"),
)
@Composable
fun FieldHint(text: String) = FieldHintText(text = text, id = null)

@Deprecated(
    "Pass help and error to FormField, which links them to the control with aria-describedby",
    ReplaceWith("FormField(label = null, help = help, error = error) { }"),
)
@Composable
fun FieldHelpOrError(help: String?, error: String?) =
    FieldMessageBlock(help = help, error = error, ids = null, reserve = false)
